<template>
  <div class="pure-button-group" role="group">
    <button class="pure-button radio radio-left" @click.prevent="updateValue('Commercial')"
            :class="{ active: isCommercial }">Commercial
    </button>
    <button class="pure-button radio radio-right" @click.prevent="updateValue('Residential')"
            :class="{ active: isResidential }">Home
    </button>
  </div>
</template>

<script>
  export default {
    name: 'AddressType',
    props: ['value'],
    methods: {
      updateValue(value) {
        this.$emit('input', value);
      },
    },
    computed: {
      isCommercial() {
        return this.value === 'Commercial';
      },
      isResidential() {
        return this.value === 'Residential';
      },
    },
  };
</script>


// WEBPACK FOOTER //
// AddressType.vue?63e4f2b4